import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { abfSerializeQueryArgs, marketsPublicBaseQuery } from "./util";
import { FarmingInfoResponse, PartnerInfoResponse } from "../types/ecosystem";
import { ROUTE_GET_FARMING_INFOS, ROUTE_GET_PARTNERS } from "../constants";

const ECOSYSTEM_TAG = "Ecosystem";

export const ecosystemApi = createApi({
    reducerPath: "ecosystemApi",
    tagTypes: [ECOSYSTEM_TAG],
    baseQuery: marketsPublicBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,

    endpoints: (builder) => ({
        partners: builder.query<PartnerInfoResponse, void>({
            providesTags: [ECOSYSTEM_TAG],
            query() {
                return {
                    url: ROUTE_GET_PARTNERS,
                    method: "GET"
                };
            }
        }),
        farmingInfos: builder.query<FarmingInfoResponse, void>({
            providesTags: [ECOSYSTEM_TAG],
            query() {
                return {
                    url: ROUTE_GET_FARMING_INFOS,
                    method: "GET"
                };
            }
        })
    })
});

export const { usePartnersQuery, useFarmingInfosQuery } = ecosystemApi;

export const useEcosystemApi = () => {
    const dispatch = useDispatch();

    return {
        resetEcosystemsApi: () => dispatch(ecosystemApi.util.invalidateTags([ECOSYSTEM_TAG]))
    };
};
